<template>
    <v-container fluid class="container-full-bg-gray">
    <app-row>
        <app-col cols="12">
            <app-page-card>
                <template #header>
                  Mis Documentos
                </template>
                <v-card>
                  <v-card-text  class="px-0 pt-0 card-title-footer-color">
                
                    <v-data-table
                      :loading="loading"
                      :items="my_items"
                      :headers="headers"
                      :footer-props="{
                        'items-per-page-options': [5, 10, 100, 1000],
                        'items-per-page-text': 'Empresas por página:',
                      }">
  
                    </v-data-table>       
                  </v-card-text>
                </v-card>
            </app-page-card>
        </app-col>
    </app-row>
  </v-container>
  </template>
  
<script>
import AppPageCard from '@/components/layout/AppPageCard.vue';
import AppSelect from '@/components/layout/AppSelect.vue';
import AppContainer from '@/components/layout/AppContainer.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import { query_dispatcher_get, query_dispatcher } from "@/api/client";
import { mapGetters } from "vuex";

export default {
    name: 'DashboardGestor',
    components: {
        AppPageCard,
        AppContainer,
        AppCol,
        AppRow,
        AppSelect
    },
    data() {
        return {
            my_items:[],
            loading:false,
            headers: [
                {
                text: 'Empresa',
                align: 'start',
                sortable: false,
                value: 'name',
                },
                { text: 'Pendiente', value: 'pending' },
                { text: 'Pendiente de aprobación', value: 'waiting_approval' },
                { text: 'Aprobado', value: 'approved' },
                { text: 'Rechazado', value: 'rejected' },
                { text: 'Saldo insuficiente', value: 'insufficient_credits' },
                { text: 'Error', value: 'error' },
                { text: 'Completado', value: 'done' },
            ]
        }
    },
    computed:{    
        ...mapGetters({
        userData: 'me/userData',
        got_feature: 'got_feature',
        }),
    },
    async mounted(){
        let args = {}
        this.loading = true //indica en el frontend que la càrrega de dades ha començat
        this.my_items = await query_dispatcher_get.dispatch('get.dashboard.gestor.info', args)
        this.loading = false
        console.log(this.my_items)
  }
}
</script>

<style scoped>
.card-title-footer-color {
    background: #FAFAFF;
}
::v-deep .v-data-table-header > tr > th > span{
    color: var(--v-primary-base);
}
::v-deep .v-data-table-header > tr > th{
    background-color: var(--v-primaryLight-base) !important;
}
</style>